import { get } from 'lodash';

import { BannerId, Callout } from '../../typings/banners';
import { CalloutEditorItem, EditedBanner, getEditedBannerWithCallouts } from '../../typings/bannersEditState';
import { ValidationErrorData } from '../../typings/common';

export function getCalloutsStringWidth(calloutsData: (Callout | CalloutEditorItem)[]): number {
    return calloutsData.reduce((sum, callout) => {
        return sum + callout.text.length;
    }, 0);
}

export function getCalloutsErrorsFromEditBanners(
    banners: Record<string, EditedBanner>
): Record<BannerId, ValidationErrorData[]> {
    return Object.keys(banners).reduce((acc, key) => {
        const banner = getEditedBannerWithCallouts(banners[key]);

        if (banner) {
            acc[key] = get(banner.errors, 'callouts.errors', []);
        }

        return acc;
    }, {});
}
